import { GetDataWOBody, CreateData } from '../commons/helper';

const getNotifications = async () => {
  const url = process.env.REACT_APP_API_URL + "notifications";
  let result = { notifications: [], unreadCount: 0 };
  await GetDataWOBody(url).then(x => { if (x) result = x; });
  return result;
};

const markAsRead = async (b) => {
  await CreateData(b, process.env.REACT_APP_API_URL + "notifications-read");
};

const markAllAsRead = async () => {
  await CreateData({}, process.env.REACT_APP_API_URL + "notifications-read-all");
};

const deleteNotification = async (b) => {
  await CreateData(b, process.env.REACT_APP_API_URL + "notifications-delete");
};

const deleteAllRead = async () => {
  await CreateData({}, process.env.REACT_APP_API_URL + "notifications-delete-read");
};

export { getNotifications, markAsRead, markAllAsRead, deleteNotification, deleteAllRead };